<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-flag-docs-preview></ui-flag-docs-preview></p>
<h1 id="description">Description</h1>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-flag</span> <span class="hljs-attr">culture</span>=<span class="hljs-string">"se"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-flag</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-flag</span> <span class="hljs-attr">culture</span>=<span class="hljs-string">"se"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"small"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-flag</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-flag</span> <span class="hljs-attr">culture</span>=<span class="hljs-string">"se"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"tiny"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-flag</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">culture</td>
<td align="left">Culture receives ISO 3166-1 alpha-2 code [Two-letters country codes] Culture code can also be in the format &quot;en-us&quot; and it will be treated as &quot;us&quot; &#64;summary:<br/> Icon of the flag.</td>
</tr>
<tr>
<td align="left">size</td>
<td align="left">Size can be either &#39;tiny&#39; or &#39;small&#39; or empty &#64;summary:<br/> Size of the icon.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
